module.exports = __webpack_public_path__ + "static/media/planning.b062d09c.png";